import { useEffect } from 'react'

import { trace } from '@opentelemetry/api'

const tracer = trace.getTracer('route-error-tracer')

interface GenericErrorModalProps {
  error: Error
}

export const GenericErrorPage = () => {
  // If react does fallback to this page, it means there was an unhandled error.
  // We should log this error to the monitoring system.
  const span = tracer.startSpan('GenericErrorPage')
  useEffect(() => {
    span.recordException(new Error('Unhandled react error'))
    span.setStatus({ code: 2, message: 'Unhandled React Error' })
    span.end()
  }, [span])

  return (
    <div className="min-h-full bg-white px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="mx-auto max-w-max">
        <main className="sm:flex">
          <p className="text-4xl font-bold tracking-tight text-indigo-600 sm:text-5xl">404</p>
          <div className="sm:ml-6">
            <div className="sm:border-l sm:border-gray-200 sm:pl-6">
              <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">Page not found</h1>
              <p className="mt-1 text-base text-gray-500">Please check the URL in the address bar and try again.</p>
            </div>
            <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
              <a
                href="#"
                className="inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                Go back home
              </a>
              <a
                href="#"
                className="inline-flex items-center rounded-md border border-transparent bg-indigo-100 px-4 py-2 text-sm font-medium text-indigo-700 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                Contact support
              </a>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}

export const GenericErrorModal = ({ error }: GenericErrorModalProps) => {
  return (
    <div className="h-full rounded-lg bg-white p-6 shadow-lg">
      <h2 className="font-bold text-red-600">Something went wrong!</h2>
      <p>{error.message}</p>
    </div>
  )
}
